import React from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { useIsEmbeddedMobile } from '../../../_hooks/useIsEmbeddedMobile';
import { EmptyState } from '../../../CommonComponents/OPL/AsyncStates/EmptyState/EmptyState';
import { ErrorState } from '../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { ColumnChart } from '../../../CommonComponents/OPL/charts/ColumnChart/ColumnChart';
import { ColumnChartLoading } from '../../../CommonComponents/OPL/charts/ColumnChart/ColumnChart.loading';
import { formatPercentage } from '../../../CommonUtils/formatNumber';
import { usePerformanceChartCard } from '../../hooks/usePerformanceChart';

const CHART_HEIGHT = 340;

interface Props {
  title: string;
}

export const PerformanceChart = ({ title }: Props) => {
  const isEmbeddedMobile = useIsEmbeddedMobile();

  return (
    <Box display="flex" flexDirection="column" height="100%">
      {isEmbeddedMobile && (
        <Box mx="16">
          <Text variant="smallCaps" mt="24">
            {title}
          </Text>
        </Box>
      )}

      <PerformanceChartContent />
    </Box>
  );
};
const PerformanceChartContent = () => {
  const { data, isFetching, error, refetch } = usePerformanceChartCard();

  const isEmbeddedMobile = useIsEmbeddedMobile();

  if (isFetching) {
    return (
      <ColumnChartLoading
        isStacked={false}
        categoriesCount={1}
        chartHeight={isEmbeddedMobile ? CHART_HEIGHT : 280}
      />
    );
  }

  if (error) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" py="24" height="100%">
        <ErrorState onAction={refetch} />
      </Box>
    );
  }

  if (!data || (data && data.categories.length === 0)) {
    return (
      <Box height="100%" display="flex" alignItems="center" justifyContent="center" py="56">
        <EmptyState />
      </Box>
    );
  }

  return (
    <ColumnChart
      series={data.series}
      categories={data.categories}
      yAxisType="percentage"
      customSettings={{
        legend: {
          enabled: false,
        },

        chart: {
          height: isEmbeddedMobile ? CHART_HEIGHT : 280,
        },

        tooltip: {
          shared: true,

          formatter() {
            let tooltip = `
                      <span style="font-size: 10px">
                        ${(this as any).x}
                      </span><table>
                    `;

            if ((this as any).points) {
              (this as any).points.forEach(({ y, color }) => {
                tooltip += `
                          <tr>
                            <td>
                              <span style="color:${color}">\u25CF</span>
                            </td>
                            <td>
                              <span style="font-weight: 600">
                                ${formatPercentage(Number(y), { decimalPlaces: 2 })}
                              </span>
                            </td>
                          </tr>
                        `;
              });
            }

            return `${tooltip}</table>`;
          },
        },
      }}
    />
  );
};
